import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { initGtag, sendPageView } from "../../analytics/gtag";

function PageViewTracker({ analyticsAllowed }) {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!analyticsAllowed) return;
    initGtag();
    sendPageView(pathname + search);
  }, [analyticsAllowed, pathname, search]);

  return null;
}

export default PageViewTracker;
